import { Injectable } from '@angular/core';

export enum EventSource {
  SEARCH = 'search',
  PANEL = 'panel',
  TOOLBAR = 'toolbar',
}

@Injectable({
  providedIn: 'root',
})
export class EventManagerService {
  private readonly sources: Partial<Record<EventSource, { close: () => void }>> = {};

  closeOtherSources(source: EventSource): void {
    setTimeout(() => {
      Object.entries(this.sources).forEach(([key, value]) => {
        if (key !== source) {
          value.close();
        }
      });
    });
  }

  closeSource(source: EventSource): void {
    const sourceToClose = this.sources[source];
    if (sourceToClose) {
      sourceToClose.close();
    }
  }

  closeSources(...sources: EventSource[]): void {
    sources.forEach((source) => {
      this.closeSource(source);
    });
  }

  registerSource(source: EventSource, close: () => void): void {
    this.sources[source] = { close };
  }
}
